// Utility for highlighting search matches and scrolling to first match

// Escape user input for regex safety
const escapeRegex = (str: string) => str.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

export function highlightMatches(containerEl: HTMLElement, query: string) {
  if (!query) return;

  const rx = new RegExp(`\\b${escapeRegex(query)}\\b`, "gi"); // whole word
  const walker = document.createTreeWalker(containerEl, NodeFilter.SHOW_TEXT);
  const textNodes = [];
  
  while (walker.nextNode()) {
    textNodes.push(walker.currentNode);
  }

  let firstMark: HTMLElement | null = null;
  
  for (const tn of textNodes) {
    const text = tn.nodeValue;
    if (!text || !rx.test(text)) continue;
    
    const frag = document.createDocumentFragment();
    let last = 0;
    rx.lastIndex = 0;
    
    for (const match of text.matchAll(rx)) {
      // Add text before the match
      if (match.index && match.index > last) {
        frag.append(text.slice(last, match.index));
      }
      
      // Add the highlighted match
      const mark = document.createElement("mark");
      mark.className = "bg-yellow-200 text-yellow-900 px-1 rounded";
      mark.textContent = match[0];
      frag.append(mark);
      
      if (!firstMark) firstMark = mark;
      last = (match.index || 0) + match[0].length;
    }
    
    // Add remaining text
    frag.append(text.slice(last));
    tn.parentNode?.replaceChild(frag, tn);
  }
  
  // Scroll to first match
  if (firstMark) {
    setTimeout(() => {
      firstMark?.scrollIntoView({ 
        block: "center", 
        behavior: "smooth" 
      });
    }, 100);
  }
}

export function clearHighlights(containerEl: HTMLElement) {
  const marks = containerEl.querySelectorAll('mark');
  marks.forEach(mark => {
    const parent = mark.parentNode;
    if (parent) {
      parent.insertBefore(document.createTextNode(mark.textContent || ''), mark);
      parent.removeChild(mark);
    }
  });
}